export default {
    FLIGHT: 'flights-direct',
    GENERAL_TRAVEL: 'travel-direct',
    FACEBOOK: 'facebook-direct'
}
